import { Body, Box, Heading } from '@hover/blueprint';
import React, { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useInterSectionObserver } from '../../../hooks';

const interSectionOption = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5,
};

const AboutSectionsDesktop: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<number>(1);

  const firstSectionRef = useInterSectionObserver(isIntersecting => {
    if (isIntersecting) {
      setCurrentSection(1);
    }
  }, interSectionOption);

  const secondSectionRef = useInterSectionObserver(isIntersecting => {
    if (isIntersecting) {
      setCurrentSection(2);
    }
  }, interSectionOption);

  const thirdSectionRef = useInterSectionObserver(isIntersecting => {
    if (isIntersecting) {
      setCurrentSection(3);
    }
  }, interSectionOption);

  return (
    <Box
      display={{ base: 'none', desktop: 'flex' }}
      position="relative"
      w="100%"
    >
      <Box
        pt={1000}
        flex={1}
        position="sticky"
        top={0}
        height="100vh"
        flexDir="row"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          opacity={currentSection === 1 ? 1 : 0}
          w={currentSection === 1 ? '380px' : 0}
          h={currentSection === 1 ? '561px' : 0}
          transition="opacity 0.8s linear 0.2s"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_design_tools_homeowner.png"
            alt="about hover design tools for homeowners"
            objectFit="contain"
          />
        </Box>
        <Box
          opacity={currentSection === 2 ? 1 : 0}
          w={currentSection === 2 ? '380px' : 0}
          h={currentSection === 2 ? '380px' : 0}
          transition="opacity 0.8s linear 0.2s"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_productivity.png"
            alt="about hover collaboration"
            objectFit="contain"
          />
        </Box>
        <Box
          opacity={currentSection === 3 ? 1 : 0}
          w={currentSection === 3 ? '380px' : 0}
          h="355px"
          transition="opacity 0.8s linear 0.2s"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/about_hover_collaboration.png"
            alt="about hover collaboration"
          />
        </Box>
      </Box>
      <Box flex={1} height="300vh" flexDir="column">
        <Box
          mt={500}
          ref={firstSectionRef.elementRef}
          height="100vh"
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
          pl={1000}
        >
          <Heading
            mb={400}
            size={700}
            fontWeight="headingLight"
            marginBottom={200}
          >
            Design Tools for Homeowners
          </Heading>
          <Body size={500} mb={500} maxW="90%">
            Select and see real products - roofing, siding, windows, and more -
            on a virtual 3D model of your home.
          </Body>
          <Body mb={500} size={500} isBold maxW="70%">
            Home improvement is a big deal - we take the guesswork out.
          </Body>
        </Box>
        <Box
          ref={secondSectionRef.elementRef}
          height="100vh"
          flexDir="column"
          alignItems="flex-start"
          pl={1000}
          justifyContent="center"
        >
          <Heading mb={400} size={700} isLight marginBottom={200}>
            Productivity Tools for Professionals
          </Heading>
          <Body size={500} mb={500} maxW="90%">
            Easier, more accurate measurements, automatic estimations, populated
            takeoffs, direct supplier ordering... all in one place.
          </Body>
          <Body mb={500} size={500} isBold maxW="70%">
            Get more done by working smarter, not harder.
          </Body>
        </Box>
        <Box
          ref={thirdSectionRef.elementRef}
          height="100vh"
          flexDir="column"
          alignItems="flex-start"
          pl={1000}
          justifyContent="center"
        >
          <Heading mb={400} size={700} mt={700} isLight marginBottom={200}>
            Collaboration at Its Best
          </Heading>
          <Body size={500} mb={500} maxW="90%">
            Homeowners and pros can use our tools together -- virtually or in
            person -- to select materials, build estimates, and sign proposals.
          </Body>
          <Body mb={500} size={500} isBold maxW="70%">
            Transparent collaboration builds trust and results in an honest,
            fair deal for all.{' '}
          </Body>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSectionsDesktop;
